import * as React from 'react';
import {AssetField} from "../../api";
import {FieldHelper} from "../utils/FieldHelper";

interface IAssetComponent {
    fields?: Array<AssetField>;
}

const AssetComponent = ({fields}: IAssetComponent) => {

    function renderField(assetField: AssetField, index: number) {
        if (!assetField.name || !assetField.value) {
            return <></>
        } else {
            return (
                <div className={"asset-metadata-item mb-2 metadata-" + assetField.name} key={'index_' + index + 1}>
                    <label className="w-100 metadata-label">{FieldHelper.getPrettyName(assetField.name)}</label>
                    <div className="w-100 metadata-value" title={assetField.value as any}>{assetField.value as any}</div>
                </div>
            );
        }
    }

    function getFieldsOrdered(fields: Array<AssetField>) {
        return fields
            .filter(a => a.name !== "Id")
            .sort((a, b) => FieldHelper.getFieldOrderSortResult(a.name, b.name));
    }

    if (!fields) {
        return <></>;
    } else {

        return <>{
            getFieldsOrdered(fields).map((field, index) => renderField(field, index))
        }</>;

    }

};

export default AssetComponent;
